export function toQueryParamsString(queryParamsObject: { [key: string]: string | number }): string {
  return Object.entries(queryParamsObject)
    .filter(([, value]) => value)
    .map(([name, value]) => `${name}=${encodeURIComponent(value)}`)
    .join('&');
}
